import Component from '../core/Component'

export default class AnimatedLink extends Component {
    prepare() {
        const text = this.element.textContent.trim()

        const letters = text
            .split('')
            .map((letter) => `<span class="u-letter">${letter}</span>`)
            .join('')

        this.element.innerHTML = `
            <span class="u-line">${letters}</span>
            <span class="u-line u-line--hover">${letters}</span>
        `
    }
}
